import R from 'ramda';

const getAvatar = R.pathOr('', [
  'activationModal',
  'uploadAvatar',
  'avatarURL',
]);

export default getAvatar;
